import { Link } from "gatsby"
import React from "react"
import * as style from "./style.module.css"
import json from "../../siteData.json"

const Component = () => {
  const data = json.footer

  return (
    <div className={style.container}>
      <div className={style.container_inner}>
        <div className={style.heading}>CONTACT</div>
        <p>
          以下の電話番号もしくはコンタクトフォームから
          <br className={"is-pc"} />
          お問い合わせください
        </p>
        <div className={style.tel}>
          TEL:<a href={`tel:0112159875`}>011-215-9875</a>
        </div>
        <Link className={style.button} to={"/contact"}>
          {data.contactButton}
        </Link>
      </div>
    </div>
  )
}

export default Component
